import {
  type CancelledOrder,
  type CheckoutQuery,
  type HighFrequency_AddOnRestriction,
  type HighFrequency_AddOnRestriction_ExcludeSelectedNumbers,
  HighFrequency_AddOnRestrictionType,
  type OrderPollQuery,
  type PayWithTopUp,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export const isCancelledOrder = (order: OrderPollQuery['order']): order is CancelledOrder => {
  const cancelledOrder = order as CancelledOrder
  return cancelledOrder?.cancelReasonType !== undefined
}

export const isPayWithTopUp = (pay: CheckoutQuery['checkout']['payment']): pay is PayWithTopUp => {
  const payWithTopUp = pay as PayWithTopUp
  return payWithTopUp?.initial !== undefined && payWithTopUp?.stored !== undefined
}

export const isEProtectResponseSuccess = (
  response: LooseObject,
): response is EProtectResponseSuccess => {
  const responseSuccess = response as EProtectResponseSuccess
  return responseSuccess.paypageRegistrationId !== undefined && responseSuccess.type !== undefined
}

export const isHighFrequencyAddOnExcludeSelectedNumbers = (
  restriction: HighFrequency_AddOnRestriction,
): restriction is HighFrequency_AddOnRestriction_ExcludeSelectedNumbers =>
  restriction.type === HighFrequency_AddOnRestrictionType.ExcludeSelectedNumbers
